import { CommonModule } from '@angular/common'
import { HttpClient } from '@angular/common/http'
import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { Backend, Media } from '../../enums/enums'
import { DdcTextGradientComponent } from '../ddc-text-gradient/ddc-text-gradient.component'

export interface ExploreElement {
  id: number
  title: string
  owner: {
    username: string
    profile_pic: string
    is_verified: boolean
  }
  words_count: number
  pairs_count: number
  created_at: string
}

export interface ExploreElementResponse {
  count: number
  next: string | null
  previous: string | null
  results: ExploreElement[]
}

@Component({
  selector: 'ddc-explored-cards',
  templateUrl: './ddc-explored-cards.component.html',
  styleUrls: ['./ddc-explored-cards.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [CommonModule, RouterModule, AngularMaterialsModules, DdcTextGradientComponent],
})
export class DdcExploredCardsComponent implements OnInit {
  _elements: ExploreElement[] = []
  _currentIndex = 0
  _isLoading = true
  _isFetchingMore = false
  _page = 1
  _hasNext = false
  _assets = Media.ASSETS
  _media = Media.MEDIA

  private _defaultProfilePic =
    'https://st3.depositphotos.com/6672868/13701/v/600/depositphotos_137014128-stock-illustration-user-profile-icon.jpg'

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.fetchExploreElements()
  }

  fetchExploreElements(): void {
    const isInitial = this._elements.length === 0
    if (isInitial) {
      this._isLoading = true
    } else {
      this._isFetchingMore = true
    }
    this.http
      .get<ExploreElementResponse>(`${Backend.HOST_CONTAINER}ddc/explore/?page=${this._page}`)
      .subscribe({
        next: res => {
          this._elements = [...this._elements, ...res.results]
          this._hasNext = res.next !== null
          this._isLoading = false
          this._isFetchingMore = false
        },
        error: () => {
          this._isLoading = false
          this._isFetchingMore = false
        },
      })
  }

  onPrevious(): void {
    if (this._currentIndex > 0) {
      this._currentIndex--
    }
  }

  onNext(): void {
    if (this._currentIndex < this._elements.length - 1) {
      this._currentIndex++
      // Prefetch next page when near end
      if (this._currentIndex >= this._elements.length - 2 && this._hasNext) {
        this._page++
        this.fetchExploreElements()
      }
    }
  }

  getProfilePic(element: ExploreElement): string {
    if (!element.owner.profile_pic || element.owner.profile_pic === 'null') {
      return this._defaultProfilePic
    }
    if (element.owner.profile_pic.startsWith('http')) {
      try {
        const pathname = new URL(element.owner.profile_pic).pathname
        // pathname is like /media/license.jpeg — strip leading /media/
        const relative = pathname.replace(/^\/media\//, '')
        return this._media + relative
      } catch {
        return this._defaultProfilePic
      }
    }
    return this._media + element.owner.profile_pic
  }

  handleImageError(event: Event): void {
    const img = event.target as HTMLImageElement
    img.src = this._defaultProfilePic
  }

  goToUser(username: string, event: Event): void {
    event.stopPropagation()
    this.router.navigate(['/users/' + username])
  }

  goToDictionary(elem: ExploreElement): void {
    this.router.navigate(['/library/dic/' + elem.id + '/' + elem.owner.username])
  }
}
